import { render, staticRenderFns } from "./formula.vue?vue&type=template&id=25d2120d&scoped=true&"
import script from "./formula.vue?vue&type=script&lang=js&"
export * from "./formula.vue?vue&type=script&lang=js&"
import style0 from "./formula.vue?vue&type=style&index=0&id=25d2120d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d2120d",
  null
  
)

export default component.exports